/**
 * Transaction status types
 *
 * Represents the lifecycle of a blockchain transaction
 * from preparation through confirmation or failure.
 */

export type TransactionStatus =
	| "idle"
	| "preparing"
	| "awaiting_signature"
	| "pending"
	| "confirmed"
	| "failed"
	| "rejected";

/**
 * All valid transaction statuses as a readonly array.
 * Useful for validation and iteration.
 */
export const TRANSACTION_STATUSES: readonly TransactionStatus[] = [
	"idle",
	"preparing",
	"awaiting_signature",
	"pending",
	"confirmed",
	"failed",
	"rejected",
];

/**
 * Set of valid transaction statuses for O(1) lookup in type guard.
 */
const TRANSACTION_STATUS_SET: ReadonlySet<string> = new Set(TRANSACTION_STATUSES);

/**
 * Type guard for TransactionStatus
 */
export function isTransactionStatus(value: unknown): value is TransactionStatus {
	return typeof value === "string" && TRANSACTION_STATUS_SET.has(value);
}
